import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDoupleCheckmark2Small: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="douple-checkmark-2-small"><path d="M4.5 13L7.5 16L14.5 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.5 16L19.5 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDoupleCheckmark2Small;
